export { default } from './SensorResource';
